import styled from 'styled-components'

export const Header = styled.header`
  min-height: 80px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0;
  background-color: #fff;
  padding: 0 1%;
  box-shadow: 1px 1px 16px -8px #797979;
  z-index: 999;
`

export const HeaderLink = styled.a`
  color: white;
  text-decoration: underline;
  font-size: 13px;
  font-weight: 700;
  margin-right: 30px;
  cursor: pointer;
  :hover {
    color: white;
    text-decoration: underline;
  }
`
